import { useParams } from 'react-router-dom';
import { ItemCreationForm } from './ItemCreatorForm';

export function ItemCreatorDuplicateFormWrapper() {
    const { id } = useParams();

    return (
        <ItemCreationForm loadId={id}/>
    );
}